(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/views/drawselector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/views/drawselector.js');

'use strict';

const _svs$sport$drawselect = svs.sport.drawselector,
  views = _svs$sport$drawselect.views,
  collections = _svs$sport$drawselect.collections;
const Drawselector = Marionette.View.extend({
  regions: {
    headerRegion: '#drawselector-header',
    listRegion: '#drawselector-list'
  },
  childViewEvents: {
    'show:menu': 'toggleMenu',
    changeRound: 'changeRound'
  },
  template: data => svs.sport.drawselector.templates.drawselector(data),
  initialize(options) {
    svs.sport.drawselector.collections.drawselectorCollection = new collections.DrawselectorList();
    svs.sport.drawselector.collections.drawselectorCollection.setData(options.draws, options.currentDraw);
  },
  onRender() {
    const model = svs.sport.drawselector.collections.drawselectorCollection.getCurrentDraw();
    model.set('disableSlideDown', this.options.draws.length === 1);
    this.showChildView('headerRegion', new views.DrawselectorHeader({
      model,
      branding: this.options.branding
    }));
  },
  toggleMenu(shouldOpenMenu) {
    const self = this,
      listRegion = this.getRegion('listRegion');
    if (shouldOpenMenu) {
      if (!listRegion.hasView()) {
        const list = new views.DrawselectorList({
          collection: svs.sport.drawselector.collections.drawselectorCollection
        });
        list.on('attach', () => {
          listRegion.$el.slideDown('fast', () => {
            if (self.options.swiperUpdateFunction) {
              self.options.swiperUpdateFunction();
            }
          });
        });
        this.$('#drawselector-list').hide();
        this.showChildView('listRegion', list);
      } else {
        listRegion.$el.slideDown('fast', () => {
          if (self.options.swiperUpdateFunction) {
            self.options.swiperUpdateFunction();
          }
        });
      }
    } else {
      listRegion.$el.slideUp('fast', () => {
        if (self.options.swiperUpdateFunction) {
          self.options.swiperUpdateFunction();
        }
      });
    }
  },
  changeRound(drawNumber) {
    this.options.callback(drawNumber);
  }
});
setGlobal('svs.sport.drawselector.views.Drawselector', Drawselector);

 })(window);